import React from "react";
import { FiDatabase, FiCpu, FiLayers } from "react-icons/fi";
import "../styles/Services.css";

const services = [
  {
    icon: <FiDatabase />,
    title: "SAP to Power BI",
    desc: "Dashboards on your SAP FI, CO, SD, MM, PP and HCM data, covering extraction, modelling, reconciliation and secure publishing.",
  },
  {
    icon: <FiCpu />,
    title: "Agentic Reporting",
    desc: "Python and AI agents that email reports on schedule, alert you when a KPI moves, flag mismatches between systems and validate every release.",
  },
  {
    icon: <FiLayers />,
    title: "Power BI Platform",
    desc: "Power BI Service and Fabric setup, data gateways, row-level security, CI/CD on GitHub and documentation your team can maintain.",
  },
];

const steps = [
  { title: "Discovery call", desc: "A free call to understand your data, systems and goals." },
  { title: "Free proof of concept", desc: "A one-page dashboard built from your CSV export." },
  { title: "Build", desc: "End-to-end dashboards and automation on your SAP data." },
  { title: "Run & improve", desc: "Monitoring, weekly check-ins and new reports as you grow." },
];

export default function Services() {
  return (
    <section id="services">
      <div className="section-header">
        <span className="section-title">Services</span>
      </div>

      <div className="services-grid">
        {services.map((service) => (
          <div key={service.title} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>

      <h3 className="process-title">How it works</h3>
      <ol className="process-steps">
        {steps.map((step) => (
          <li key={step.title}>
            <h4>{step.title}</h4>
            <p>{step.desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
